import { SelectionFeature } from "src/js/stores/map/store";
import { MAX_AREA_CONSTRAINT_HECTARES } from "./constants";
import { useMaxSelectionArea } from "../utils/useMaxSelectionArea";

export function useMaxAreaSelectedElevationConstraint(selection: SelectionFeature) {
  return useMaxSelectionArea(selection, MAX_AREA_CONSTRAINT_HECTARES);
}
